import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import { randomString } from '../helper/utils/common';
import Cookie from 'js-cookie';
/**
 * 获取设备信息
 * @returns object
 */

var getSystemData = function getSystemData() {
  return {
    connection: getConnection(),
    isHaveOntouch: getIsHaveOntouch(),
    isNightmare: getIsNightmare(),
    isPhantom: getIsPhantom(),
    windowToString: window.toString() || '',
    websocketError: getWebSocketError(),
    math: getMath(),
    orientation: getOrientation(),
    dateLocale: getDateLocale(),
    audio: getAudio(),
    fonts: getFonts(),
    clientRects: getClientRects(),
    permissions: getPermissions(),
    fakeProfile: getFakeProfile(),
    glyphs: getGlyphs(),
    screenLeft: getScreenLeft(),
    bodyClient: getBodyClient(),
    webglMvd: getWebglMvd(),
    offsetWidth: getOffsetWidth(),
    offsetHeight: getOffsetHeight(),
    genError: getGenError(),
    createAnalyser: getCreateAnalyser(),
    canvasToDataUrl: getCanvasToDataUrl(),
    rtc: getRtcFn(),
    enumerateDevices: getEnumerateDevicesFn(),
    cssSupport: getCssSupport(),
    canvasRect: getCanvasRect(),
    selenium: getIsSelenium(),
    // randomString: getRandomString(),
    fontFlash: getFontFlash()
  };
};
/**
 * 获取随机数
 * @returns string
 */


var getFontFlash = function getFontFlash() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  try {
    var hasSwfObjectLoaded = function hasSwfObjectLoaded() {
      return typeof window.swfobject !== 'undefined';
    };

    var hasMinFlashInstalled = function hasMinFlashInstalled() {
      return window.swfobject.hasFlashPlayerVersion('9.0.0');
    };

    var addFlashDivNode = function addFlashDivNode(options) {
      var node = document.createElement('div');
      node.setAttribute('id', options.fonts.swfContainerId);
      document.body.appendChild(node);
    };

    var loadSwfAndDetectFonts = function loadSwfAndDetectFonts(done, options) {
      var hiddenCallback = '___fp_swf_loaded';

      window[hiddenCallback] = function (fonts) {
        done(fonts);
      };

      var id = options.fonts.swfContainerId;
      addFlashDivNode();
      var flashvars = {
        onReady: hiddenCallback
      };
      var flashparams = {
        allowScriptAccess: 'always',
        menu: 'false'
      };
      window.swfobject.embedSWF(options.fonts.swfPath, id, '1', '1', '9.0.0', false, flashvars, flashparams, {});
    }; // we do flash if swfobject is loaded


    if (!hasSwfObjectLoaded()) {
      return 'swf object not loaded';
    }

    if (!hasMinFlashInstalled()) {
      return 'flash not installed';
    }

    if (!options.fonts.swfPath) {
      return 'missing options.fonts.swfPath';
    }

    loadSwfAndDetectFonts(function (fonts) {
      return fonts;
    }, options);
  } catch (e) {
    return e;
  }
};
/**
 * 获取随机数
 * @returns string
 */


var getRandomString = function getRandomString() {
  var str = '',
      newStr,
      cookieStr,
      locolStr,
      name = '.thumbcache_al';
  var time;
  time = window.performance.now();

  try {
    cookieStr = Cookie.get(name) || undefined;
    locolStr = localStorage.getItem(name) || undefined;
    var re = /^[0-9A-Z]*$/g,
        numRe = /^[0-9]*$/g; ///^[0-9A-Z]\w{0,61}$/g

    if (cookieStr === locolStr && cookieStr !== undefined && cookieStr.length > 62 && re.test(cookieStr.slice(0, 61)) && numRe.test(cookieStr.slice(62, cookieStr.length))) str = cookieStr;else {
      str = randomString(62, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789') + _parseInt(Math.random() * 1000000);
    }
    Cookie.set(name, str, {
      expires: 365 * 2,
      path: ''
    });
    localStorage.setItem(name, str);
  } catch (e) {}

  return ((window.performance.now() - time) / 1000).toFixed(3) + ': ' + str;
};
/**
 * 获取selenium
 * @returns int
 */


var getIsSelenium = function getIsSelenium() {
  var state = false,
      arr = ['__webdriver_evaluate', '__selenium_evaluate', '__webdriver_script_function', '__webdriver_script_func', '__webdriver_script_fn', '__fxdriver_evaluate', '__driver_unwrapped', '__webdriver_unwrapped', '__driver_evaluate', '__selenium_unwrapped', '__fxdriver_unwrapped'];

  try {
    for (var p in arr) {
      var s = selenium[p];
      if (window.document[s]) state = !0x0;
    }
  } catch (e) {}

  return state;
};
/**
 * 获取_phantom
 * @returns int
 */


var getIsNightmare = function getIsNightmare() {
  var state = false,
      arr = ['__nightmare'];

  try {
    for (var p in arr) {
      if (window[arr[p]]) state = !0x0;
    }
  } catch (e) {}

  return state;
};
/**
 * 获取_phantom
 * @returns int
 */


var getIsPhantom = function getIsPhantom() {
  // window ? [ 'callPhantom' in window, '_phantom' in window, 'phantom' in window,].join(','): 'undefined'
  var state = false,
      phantom = ['_phantom', // '__nightmare',
  '_selenium', 'callPhantom', 'callSelenium', '_Selenium_IDE_Recorder'];

  try {
    for (var p in phantom) {
      if (window[phantom[p]]) state = !0x0;
    }
  } catch (e) {}

  return state;
};
/**
 * 获取enumerateDevices
 * @returns int
 */


var getCanvasRect = function getCanvasRect() {
  var t = {
    fp: '',
    winding: 0
  };

  try {
    var e = document.createElement('canvas'),
        n = e.getContext('2d');
    n && (n.canvas.width = 300, n.canvas.height = 150, n.rect(0, 0, 10, 10), n.rect(2, 2, 6, 6), t.winding = !1 === n.isPointInPath(5, 5, 'evenodd') ? 1 : 0, n.textBaseline = 'top', n.textBaseline = 'alphabetic', n.fillStyle = '#f606060', n.fillRect(125, 1, 62, 20), n.font = '30px no-real-font-meow', n.fillStyle = '#72b177', n.fillText('xtquiz Cwmfjo rlyphsve dbankg', 5, 33), n.font = '20px Arial', n.fillStyle = 'rgba(102, 204, 0, 0.7)', n.fillText("A BIG SMILING FACE \uD83D\uDE03", 50, 66), n.font = '50px sans-sefif', n.fillStyle = 'rgba(102, 204, 0, 0.7)', n.textBaseline = 'bottom', n.fillText("\xAF\\_(\u30C4)_/\xAF", 100, 120), n.globalCompositeOperation = 'multiply', n.fillStyle = 'rgb(255,0,255)', n.beginPath(), n.arc(50, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = 'rgb(0,255,255)', n.beginPath(), n.arc(100, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = 'rgb(255,255,0)', n.beginPath(), n.arc(75, 100, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = 'rgb(255,0,255)', n.arc(75, 75, 75, 0, 2 * Math.PI, !0), n.arc(75, 75, 25, 0, 2 * Math.PI, !0), n.fill('evenodd')), t.fp = d().MD5(e.toDataURL().replace('data:image/png;base64,', '')).toString();
  } catch (t) {}

  return t;
};
/**
 * 获取enumerateDevices
 * @returns int
 */


var getCssSupport = function getCssSupport() {
  var t = [],
      styles = ['zoom', 'resize', 'text-rendering', 'text-align-last', '-webkit-hyphens'];

  try {
    for (var i = 0; i < styles.length; i++) {
      t.push(styles[i] in document.documentElement.style ? 1 : 0);
    }
  } catch (e) {
    t = e.message || 'catch error';
  }

  return t.join('');
};
/**
 * 获取enumerateDevices
 * @returns int
 */


var getEnumerateDevicesFn = function getEnumerateDevicesFn() {
  var t = '';

  try {
    navigator.mediaDevices && navigator.mediaDevices.enumerateDevices && (t = navigator.mediaDevices.enumerateDevices.toString());
  } catch (e) {
    t = e.message || 'catch error';
  }

  return t;
};
/**
 * 获取RTCPeerConnection
 * @returns int
 */


var getRtcFn = function getRtcFn() {
  var t = '';

  try {
    var e = new RTCPeerConnection();
    e && RTCPeerConnection && (t = RTCPeerConnection.toString());
  } catch (t) {
    t = e && e.message || e;
  }

  return t;
};
/**
 * 获取createAnalyser
 * @returns int
 */


var getCanvasToDataUrl = function getCanvasToDataUrl() {
  var t = '';

  try {
    var e = document.createElement('canvas');
    e && e.toDataURL && (t = e.toDataURL.toString());
  } catch (t) {
    t = e.message || 'catch error';
  }

  return t;
};
/**
 * 获取createAnalyser
 * @returns int
 */


var getOffsetHeight = function getOffsetHeight() {
  var t = '';

  try {
    var e = _Object$getOwnPropertyDescriptor(HTMLElement.prototype, 'offsetHeight');

    e && e.get && (t = e.get.toString());
  } catch (t) {
    t = e.message || 'catch error';
  }

  return t;
};
/**
 * 获取createAnalyser
 * @returns int
 */


var getCreateAnalyser = function getCreateAnalyser() {
  var t = [];

  try {
    var audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    audioCtx && audioCtx.createAnalyser && (t = audioCtx.createAnalyser.toString());
  } catch (e) {
    t = e.message || 'catch error';
  }

  return t;
};
/**
 * 获取json报错
 * @returns int
 */


var getGenError = function getGenError() {
  var t = [];

  try {
    sjarsdfg;
  } catch (e) {
    t.push(e.message);
  }

  try {
    JSON.parse('<html></html>');
  } catch (e) {
    t.push(e.toString());
  }

  return t.join('|');
};
/**
 * 获取OffsetWidth
 * @returns int
 */


var getOffsetWidth = function getOffsetWidth() {
  var t = '';

  try {
    var e = _Object$getOwnPropertyDescriptor(HTMLElement.prototype, 'offsetWidth');

    e && e.get && (t = e.get.toString());
  } catch (t) {}

  return t;
};
/**
 * 获取webgl MAX_VIEWPORT_DIM函数
 * @returns int
 */


var getWebglMvd = function getWebglMvd() {
  var t = '';

  try {
    var e = document.createElement('canvas'),
        n = e.getContext('webgl') || e.getContext('webgl2') || e.getContext('experimental-webgl');
    n && (t = n.getParameter(n.MAX_VIEWPORT_DIMS).constructor.toString());
  } catch (t) {}

  return t;
};
/**
 * 获取可视宽高
 * @returns int
 */


var getBodyClient = function getBodyClient() {
  var t = [];

  try {
    t = [document.body.clientWidth || 0, document.body.clientHeight || 0];
  } catch (e) {}

  return t;
};
/**
 * 获取ScreenLeft
 * @returns int
 */


var getScreenLeft = function getScreenLeft() {
  var t = screenLeft;

  try {
    t = window.screenLeft || window.screenX;
  } catch (e) {}

  return t;
};
/**
 * 获取FakeProfile
 * @returns string
 */


var getGlyphs = function getGlyphs() {
  var t,
      e = [];

  try {
    var n = ['default', 'sans-serif', 'serif', 'monospace', 'cursive', 'fantasy'],
        r = [8377, 9601, 8378, 42813, 65533, 8376, 1478, 7838, 2431, 61443, 7386, 6109, 9134, 3330, 2946, 4442, 9253, 12334, 43056, 11014, 8676, 8381, 11387, 8368, 64494, 63504, 65535, 127, 4256, 120720, 1792, 6480, 12437, 21293, 1564, 8419, 65529, 536, 1423, 2276, 2483, 7248, 9753],
        o = document.createElement('div'),
        i = document.createElement('span');
    i.style.fontSize = '10000%';
    var a = document.body;
    a.appendChild(o), o.appendChild(i);

    for (var c = 0; c < r.length; c += 1) {
      for (var u = (t = r[c]) <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode(55296 + (t >> 10), 56320 + t % 1024)), s = 0; s < n.length; s += 1) {
        var f = n[s];
        i.style.fontFamily = 'default' === f ? '' : f, i.textContent = u;
        var l = i.offsetWidth + 'x' + o.offsetHeight;
        e.push(l);
      }
    }

    a.removeChild(o);
  } catch (t) {}

  return e.join(',');
};
/**
 * 获取FakeProfile
 * @returns string
 */


var getFakeProfile = function getFakeProfile() {
  try {
    return _ = window.Api.Injector.FakeProfile, !0;
  } catch (t) {}

  return !1;
};
/**
 * 获取用户Permissions状态
 * @returns string
 */


var getPermissions = function getPermissions() {
  var t = !1;

  try {
    navigator.permissions.query({
      name: 'notifications'
    }).then(function (e) {
      'denied' === Notification.permission && 'prompt' === e.state && (t = !0);
    });
  } catch (t) {}

  return t;
};
/**
 * 获取dom边距信息
 * @returns string
 */


var getClientRects = function getClientRects() {
  var t = '';

  try {
    var e = document.createElement('span');
    e.style.whiteSpace = 'nowrap', e.style.position = 'absolute', e.style.left = '10.5555px', e.style.top = '28.4444px', e.style.fontSize = '24.5555px', e.style.transform = 'scale(1.31123) matrix3d(0.373513, -0.0440105, 0, -0.000202461, -0.0851682, 0.616234, 0, -0.00123197, 2.17, 0.21, 1, 0.02, 13.81, 2.11, 0, 0.98)', e.style.transformOrigin = '0.1111px 0.2222px 0.3333px;', e.style.padding = '1.3333px', e.textContent = 'F i n g e r p r i n t i n g ?';
    var n = document.querySelector('body');

    if (n) {
      n.appendChild(e);

      for (var r = e.getClientRects(), o = 0; o !== r.length; o++) {
        var i = r[o];
        t += 'top:' + i.top + '|bottom:' + i.bottom + '|left:' + i.left + '|right:' + i.right + '|width:' + i.width + '|height:' + i.height + '|x:' + i.x + '|y:' + i.y + ',';
      }
    }

    e.textContent = '';
  } catch (t) {}

  return '' != t && (t = t.substring(0, t.length - 1)), t;
};
/**
 * 获取字体信息
 * @returns string
 */


var getFonts = function getFonts() {
  var t = [];

  try {
    for (var e = ['AIGDT', 'AMGDT', 'AcadEref', 'Adobe Arabic', 'Adobe Caslon Pro', 'Adobe Caslon Pro Bold', 'Adobe Devanagari', 'Adobe Fan Heiti Std B', 'Adobe Fangsong Std R', 'Adobe Garamond Pro', 'Adobe Garamond Pro Bold', 'Adobe Gothic Std B', 'Adobe Hebrew', 'Adobe Heiti Std R', 'Adobe Kaiti Std R', 'Adobe Ming Std L', 'Adobe Myungjo Std M', 'Adobe Naskh Medium', 'Adobe Song Std L', 'Agency FB', 'Aharoni', 'Alexandra Script', 'Algerian', 'Amadeus', 'AmdtSymbols', 'AnastasiaScript', 'Andalus', 'Angsana New', 'AngsanaUPC', 'Annabelle', 'Aparajita', 'Arabic Transparent', 'Arabic Typesetting', 'Arial', 'Arial Baltic', 'Arial Black', 'Arial CE', 'Arial CYR', 'Arial Cyr', 'Arial Greek', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial TUR', 'Arial Unicode MS', 'Ariston', 'Arno Pro', 'Arno Pro Caption', 'Arno Pro Display', 'Arno Pro Light Display', 'Arno Pro SmText', 'Arno Pro Smbd', 'Arno Pro Smbd Caption', 'Arno Pro Smbd Display', 'Arno Pro Smbd SmText', 'Arno Pro Smbd Subhead', 'Arno Pro Subhead', 'BankGothic Lt BT', 'BankGothic Md BT', 'Baskerville Old Face', 'Batang', 'BatangChe', 'Bauhaus 93', 'Bell Gothic Std Black', 'Bell Gothic Std Light', 'Bell MT', 'Berlin Sans FB', 'Berlin Sans FB Demi', 'Bernard MT Condensed', 'Bickham Script One', 'Bickham Script Pro Regular', 'Bickham Script Pro Semibold', 'Bickham Script Two', 'Birch Std', 'Blackadder ITC', 'Blackoak Std', 'Bodoni MT', 'Bodoni MT Black', 'Bodoni MT Condensed', 'Bodoni MT Poster Compressed', 'Book Antiqua', 'Bookman Old Style', 'Bookshelf Symbol 7', 'Bradley Hand ITC', 'Britannic Bold', 'Broadway', 'Browallia New', 'BrowalliaUPC', 'Brush Script MT', 'Brush Script Std', 'Calibri', 'Calibri Light', 'Californian FB', 'Calisto MT', 'Calligraph', 'Cambria', 'Cambria Math', 'Candara', 'Carolina', 'Castellar', 'Centaur', 'Century', 'Century Gothic', 'Century Schoolbook', 'Ceremonious Two', 'Chaparral Pro', 'Chaparral Pro Light', 'Charlemagne Std', 'Chiller', 'CityBlueprint', 'Clarendon BT', 'Clarendon Blk BT', 'Clarendon Lt BT', 'Colonna MT', 'Comic Sans MS', 'CommercialPi BT', 'CommercialScript BT', 'Complex', 'Consolas', 'Constantia', 'Cooper Black', 'Cooper Std Black', 'Copperplate Gothic Bold', 'Copperplate Gothic Light', 'Copyist', 'Corbel', 'Cordia New', 'CordiaUPC', 'CountryBlueprint', 'Courier', 'Courier New', 'Courier New Baltic', 'Courier New CE', 'Courier New CYR', 'Courier New Cyr', 'Courier New Greek', 'Courier New TUR', 'Curlz MT', 'DFKai-SB', 'DaunPenh', 'David', 'Decor', 'DejaVu Sans', 'DejaVu Sans Condensed', 'DejaVu Sans Light', 'DejaVu Sans Mono', 'DejaVu Serif', 'DejaVu Serif Condensed', 'DilleniaUPC', 'DokChampa', 'Dotum', 'DotumChe', 'Dutch801 Rm BT', 'Dutch801 XBd BT', 'Ebrima', 'Eccentric Std', 'Edwardian Script ITC', 'Elephant', 'Engravers MT', 'Eras Bold ITC', 'Eras Demi ITC', 'Eras Light ITC', 'Eras Medium ITC', 'Estrangelo Edessa', 'EucrosiaUPC', 'Euphemia', 'EuroRoman', 'Eurostile', 'FangSong', 'Felix Titling', 'Fixedsys', 'Footlight MT Light', 'Forte', 'FrankRuehl', 'Franklin Gothic Book', 'Franklin Gothic Demi', 'Franklin Gothic Demi Cond', 'Franklin Gothic Heavy', 'Franklin Gothic Medium', 'Franklin Gothic Medium Cond', 'Freehand521 BT', 'FreesiaUPC', 'Freestyle Script', 'French Script MT', 'Futura Md BT', 'GDT', 'GENISO', 'Gabriola', 'Gadugi', 'Garamond', 'Garamond Premr Pro', 'Garamond Premr Pro Smbd', 'Gautami', 'Gentium Basic', 'Gentium Book Basic', 'Georgia', 'Giddyup Std', 'Gigi', 'Gill Sans MT', 'Gill Sans MT Condensed', 'Gill Sans MT Ext Condensed Bold', 'Gill Sans Ultra Bold', 'Gill Sans Ultra Bold Condensed', 'Gisha', 'Gloucester MT Extra Condensed', 'GothicE', 'GothicG', 'GothicI', 'Goudy Old Style', 'Goudy Stout', 'GreekC', 'GreekS', 'Gulim', 'GulimChe', 'Gungsuh', 'GungsuhChe', 'Haettenschweiler', 'Harlow Solid Italic', 'Harrington', 'Heather Script One', 'Helvetica', 'High Tower Text', 'Hobo Std', 'ISOCP', 'ISOCP2', 'ISOCP3', 'ISOCPEUR', 'ISOCT', 'ISOCT2', 'ISOCT3', 'ISOCTEUR', 'Impact', 'Imprint MT Shadow', 'Informal Roman', 'IrisUPC', 'Iskoola Pota', 'Italic', 'ItalicC', 'ItalicT', 'JasmineUPC', 'Jokerman', 'Juice ITC', 'KaiTi', 'Kalinga', 'Kartika', 'Khmer UI', 'KodchiangUPC', 'Kokila', 'Kozuka Gothic Pr6N B', 'Kozuka Gothic Pr6N EL', 'Kozuka Gothic Pr6N H', 'Kozuka Gothic Pr6N L', 'Kozuka Gothic Pr6N M', 'Kozuka Gothic Pr6N R', 'Kozuka Gothic Pro B', 'Kozuka Gothic Pro EL', 'Kozuka Gothic Pro H', 'Kozuka Gothic Pro L', 'Kozuka Gothic Pro M', 'Kozuka Gothic Pro R', 'Kozuka Mincho Pr6N B', 'Kozuka Mincho Pr6N EL', 'Kozuka Mincho Pr6N H', 'Kozuka Mincho Pr6N L', 'Kozuka Mincho Pr6N M', 'Kozuka Mincho Pr6N R', 'Kozuka Mincho Pro B', 'Kozuka Mincho Pro EL', 'Kozuka Mincho Pro H', 'Kozuka Mincho Pro L', 'Kozuka Mincho Pro M', 'Kozuka Mincho Pro R', 'Kristen ITC', 'Kunstler Script', 'Lao UI', 'Latha', 'Leelawadee', 'Letter Gothic Std', 'Levenim MT', 'Liberation Sans Narrow', 'LilyUPC', 'Lithos Pro Regular', 'Lucida Bright', 'Lucida Calligraphy', 'Lucida Console', 'Lucida Fax', 'Lucida Handwriting', 'Lucida Sans', 'Lucida Sans Typewriter', 'Lucida Sans Unicode', 'MS Gothic', 'MS Mincho', 'MS Outlook', 'MS PGothic', 'MS PMincho', 'MS Reference Sans Serif', 'MS Reference Specialty', 'MS Sans Serif', 'MS Serif', 'MS UI Gothic', 'MT Extra', 'MV Boli', 'Magneto', 'Maiandra GD', 'Malgun Gothic', 'Mangal', 'Marlett', 'Matura MT Script Capitals', 'Meiryo', 'Meiryo UI', 'Mesquite Std', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft JhengHei UI', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Sans Serif', 'Microsoft Tai Le', 'Microsoft Uighur', 'Microsoft YaHei', 'Microsoft YaHei UI', 'Microsoft Yi Baiti', 'MingLiU', 'MingLiU-ExtB', 'MingLiU_HKSCS', 'MingLiU_HKSCS-ExtB', 'Minion Pro', 'Minion Pro Cond', 'Minion Pro Med', 'Minion Pro SmBd', 'Miriam', 'Miriam Fixed', 'Mistral', 'Modern', 'Modern No. 20', 'Mongolian Baiti', 'Monospac821 BT', 'Monotxt', 'Monotype Corsiva', 'MoolBoran', 'Myriad Arabic', 'Myriad Hebrew', 'Myriad Pro', 'Myriad Pro Cond', 'Myriad Pro Light', 'Myriad Web Pro', 'NSimSun', 'Narkisim', 'Niagara Engraved', 'Niagara Solid', 'Nirmala UI', 'Nueva Std', 'Nueva Std Cond', 'Nyala', 'OCR A Extended', 'OCR A Std', 'OCR-A BT', 'OCR-B 10 BT', 'Old English Text MT', 'Onyx', 'OpenSymbol', 'Orator Std', 'Ouverture script', 'PMingLiU', 'PMingLiU-ExtB', 'Palace Script MT', 'Palatino Linotype', 'PanRoman', 'Papyrus', 'Parchment', 'Perpetua', 'Perpetua Titling MT', 'Plantagenet Cherokee', 'Playbill', 'Poor Richard', 'Poplar Std', 'Prestige Elite Std', 'Pristina', 'Proxy 1', 'Proxy 2', 'Proxy 3', 'Proxy 4', 'Proxy 5', 'Proxy 6', 'Proxy 7', 'Proxy 8', 'Proxy 9', 'Raavi', 'Rage Italic', 'Ravie', 'Rockwell', 'Rockwell Condensed', 'Rockwell Extra Bold', 'Rod', 'Roman', 'RomanC', 'RomanD', 'RomanS', 'RomanT', 'Romantic', 'Rosewood Std Regular', 'Sakkal Majalla', 'SansSerif', 'Script', 'Script MT Bold', 'ScriptC', 'ScriptS', 'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Light', 'Segoe UI Semibold', 'Segoe UI Semilight', 'Segoe UI Symbol', 'Shonar Bangla', 'Showcard Gothic', 'Shruti', 'SimHei', 'SimSun', 'SimSun-ExtB', 'Simplex', 'Simplified Arabic', 'Simplified Arabic Fixed', 'Small Fonts', 'Snap ITC', 'Square721 BT', 'Stencil', 'Stencil Std', 'Stylus BT', 'SuperFrench', 'Swis721 BT', 'Swis721 BdCnOul BT', 'Swis721 BdOul BT', 'Swis721 Blk BT', 'Swis721 BlkCn BT', 'Swis721 BlkEx BT', 'Swis721 BlkOul BT', 'Swis721 Cn BT', 'Swis721 Ex BT', 'Swis721 Hv BT', 'Swis721 Lt BT', 'Swis721 LtCn BT', 'Swis721 LtEx BT', 'Syastro', 'Sylfaen', 'Symap', 'Symath', 'Symbol', 'Symeteo', 'Symusic', 'System', 'Tahoma', 'TeamViewer8', 'Technic', 'TechnicBold', 'TechnicLite', 'Tekton Pro', 'Tekton Pro Cond', 'Tekton Pro Ext', 'Tempus Sans ITC', 'Terminal', 'Times New Roman', 'Times New Roman Baltic', 'Times New Roman CE', 'Times New Roman CYR', 'Times New Roman Cyr', 'Times New Roman Greek', 'Times New Roman TUR', 'Traditional Arabic', 'Trajan Pro', 'Trebuchet MS', 'Tunga', 'Tw Cen MT', 'Tw Cen MT Condensed', 'Tw Cen MT Condensed Extra Bold', 'Txt', 'UniversalMath1 BT', 'Utsaah', 'Vani', 'Verdana', 'Vijaya', 'Viner Hand ITC', 'Vineta BT', 'Vivaldi', 'Vladimir Script', 'Vrinda', 'WP Arabic Sihafa', 'WP ArabicScript Sihafa', 'WP CyrillicA', 'WP CyrillicB', 'WP Greek Century', 'WP Greek Courier', 'WP Greek Helve', 'WP Hebrew David', 'WP MultinationalA Courier', 'WP MultinationalA Helve', 'WP MultinationalA Roman', 'WP MultinationalB Courier', 'WP MultinationalB Helve', 'WP MultinationalB Roman', 'WST_Czec', 'WST_Engl', 'WST_Fren', 'WST_Germ', 'WST_Ital', 'WST_Span', 'WST_Swed', 'Webdings', 'Wide Latin', 'Wingdings', 'Wingdings 2', 'Wingdings 3', 'ZWAdobeF'], n = e.length, r = document.createDocumentFragment(), o = [], i = 0; i < n; i += 1) {
      var a = e[i],
          c = document.createElement('div');
      a = a.replace(/['"<>]/g, ''), c.innerHTML = '<b style="display:inline !important; width:auto !important; font:normal 10px/1 \'X\',sans-serif !important">ww</b><b style="display:inline !important; width:auto !important; font:normal 10px/1 \'X\',monospace !important">ww</b>'.replace(/X/g, a), c.style.cssText = 'position: absolute; visibility: hidden; display: block !important', r.appendChild(c), o.push(c);
    }

    var u = document.body;

    for (u.insertBefore(r, u.firstChild), i = 0; i < n; i += 1) {
      var s = o[i].getElementsByTagName('b');
      s[0].offsetWidth === s[1].offsetWidth && t.push(e[i]);
    }

    for (i = 0; i < n; i += 1) {
      u.removeChild(o[i]);
    }
  } catch (s) {}

  return t.join(',');
};
/**
 * 获取音频信息
 * @returns string
 */


var getAudio = function getAudio() {
  var t = '';

  try {
    var audioContext = new window.AudioContext();
    var destination = audioContext.destination;
    t = "".concat(audioContext.sampleRate, "_").concat(destination.maxChannelCount, "_").concat(destination.numberOfInputs, "_").concat(destination.numberOfOutputs, "_").concat(destination.channelCount, "_").concat(destination.channelCountMode, "_").concat(destination.channelInterpretation);
  } catch (e) {}

  return t;
};
/**
 * 获取当前日期对象的字符串
 * @returns string
 */


var getDateLocale = function getDateLocale() {
  var t = '';

  try {
    t = new Date().toLocaleString();
  } catch (e) {}

  return t;
};
/**
 * 获取onorientationchange事件
 * @returns object
 */


var getOrientation = function getOrientation() {
  var t = {
    val: -1,
    prop: !1
  };
  return t.val = _parseInt(void 0 !== window.orientation ? window.orientation.toString() : '-1'), t.prop = window.hasOwnProperty('onorientationchange'), t;
};
/**
 * 获取数学运算值
 * @returns string
 */


var getMath = function getMath() {
  var t = '';

  try {
    t = (Math.exp(10) + 1 / Math.exp(10)) / 2 + '|' + Math.tan(-1e300);
  } catch (t) {}

  return t;
};
/**
 * 捕获 WebSocket 错误信息
 * @returns string
 */


var getWebSocketError = function getWebSocketError() {
  var err = '';

  try {
    new WebSocket('itsgonnafail');
  } catch (e) {
    err = e.message || 'catch error';
  }

  return err;
};
/**
 * 获取 ontouchstart 事件
 * @returns boolean
 */


var getIsHaveOntouch = function getIsHaveOntouch() {
  return 'ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints ? 1 : 0;
};
/**
 * 获取网络信息
 * @returns object
 */


var getConnection = function getConnection() {
  var t = {
    effectiveType: '',
    type: '',
    downlink: -1,
    downlinkMax: -1,
    rtt: -1,
    saveData: -1
  };

  try {
    if (void 0 !== window.navigator.connection) {
      var e = window.navigator.connection;
      t.effectiveType = void 0 === e.effectiveType ? '' : e.effectiveType, t.downlink = void 0 === e.downlink ? -1 : e.downlink, t.downlinkMax = void 0 === e.downlinkMax ? -1 : e.downlinkMax, t.rtt = void 0 === e.rtt ? -1 : e.rtt, t.type = void 0 === e.type ? '' : e.type, t.saveData = void 0 === e.saveData ? -1 : e.saveData ? 1 : 0;
    }
  } catch (e) {}

  return t;
};

export default getSystemData;